import {
  type FC
} from 'react';
import {
  SvgIcon,
  type SvgIconProps,
} from '@mui/joy';

export const BeamEffectIcon: FC<SvgIconProps> = props => (
  <SvgIcon
    width='34'
    height='9'
    viewBox='0 0 34 9'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    {...props}>
    {/* <g style='mix-blend-mode:plus-lighter' filter='url(#filter0_f_3924_47232)'> */}
    <g filter='url(#filter0_f_3924_47232)'>
      <ellipse cx='11' cy='4' rx='11' ry='4' transform='matrix(-1 0 0 1 28 6)' fill='#00BBFF' />
    </g>
    <defs>
      <filter id='filter0_f_3924_47232' x='0' y='0' width='34' height='20' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='3' result='effect1_foregroundBlur_3924_47232' />
      </filter>
    </defs>
  </SvgIcon>
);